<template>
  <div class="clients">
    <template v-if="isLoading">
      <c-row>
        <c-col>
          <h4 class="text-h6">Getting clients...</h4>
        </c-col>
      </c-row>
    </template>
    <template v-else>
      <c-row>
        <c-col>
          <c-card>
            <c-card-body>
              <c-data-table
                :items="clients"
                :fields="fields"
                :table-filter="{ placeholder: 'Find client', label: ' ' }"
                items-per-page-select
                :items-per-page="20"
                hover
                sorter
                pagination
                responsive
              >
                <template #no-items-view>
                  <p class="text-center p-5 h3">No clients were found matching that search.</p>
                </template>
                <template #name="{item}">
                  <td>
                    <router-link :to="{ name: 'clientDetails', params: { clientId: item._id } }">
                      {{ item.name }}
                    </router-link>
                  </td>
                </template>
                <template #active="{item}">
                  <td>
                    <c-badge :color="getBadge(item.active)">
                      {{ item.active ? 'Yes' : 'No' }}
                    </c-badge>
                  </td>
                </template>
                <template #createdAt="{item}">
                  <td>
                    {{ item.createdAt | dateFormat }}
                  </td>
                </template>
              </c-data-table>
            </c-card-body>
          </c-card>
        </c-col>
      </c-row>
    </template>
  </div>
</template>

<script>
import { buildEndpoint } from '../../libs/buildEndPoint';
import { getCompanyId } from '../../libs/user/getCompanyId';

export default {
  name: 'ClientList',
  components: {},
  data() {
    return {
      isLoading: true,
      clients: [],
      organisationId: null,
      fields: ['name', 'contactName', 'createdAt', 'contactEmailAddress', 'active'],
    };
  },
  created() {
    this.organisationId = getCompanyId(this.$store);
    this.fetchData();
  },
  methods: {
    getBadge(status) {
      return status ? 'success' : 'secondary';
    },
    clientError(error) {
      this.$store.commit('addErrorMessage', {
        header: 'Error getting clients',
        message: error && error.message ? error.message : 'There was a problem getting your list of clients.',
      });
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .get(buildEndpoint(`clients/list/${this.organisationId}`))
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.clients = response.data.data;
          } else {
            this.clientError();
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.clientError(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
.buttons {
  margin-bottom: 20px;
}
.clients-list {
  min-height: 400px;
}
.no-data {
  p {
    text-align: center;
    padding: 40px;
    font-weight: bold;
  }
}
</style>
